import React, { useEffect, useRef, useState } from "react";
import CustomButton from "../../../components/AddButton";
import { document, Plus, truck } from "../../../common/svg";
import { tripDetails } from "../../../common/staticData";
import CustomCard from "../../../components/Card";
import DaysLeftCounter from "../../../components/DaysProgress";
import CustomChip from "../../../components/Chip";
import { useNavigate } from "react-router-dom";
import ClientDetailsComponent from "../view/clientdetail";
import BookingDetails from "../view/bookingDetails";
import Booking from "../view/Trip";
import { images } from "../../../common/tabs";
import moment from "moment";
import { ApiService } from "../../../service/api.service";
import InfiniteScrollContainer from "../../../components/InfiniteScroll/InfiniteScroll";
import SecureImage from "../../../components/BucketImage/Image";
import { OPERTIONS_URL } from "../../../common/common";
import { getTripData } from "../../../Utility/apicall";

const AllBooking = ({ id }: { id?: string }) => {
  const navigate = useNavigate();
  const entityId = localStorage.getItem("entity_id");
  const apiService = new ApiService();
  const [clientId, setClientId] = useState("");
  const [activeCardIndex, setActiveCardIndex] = useState<number | null>(null);
  const [activeTripCard, setActiveTripCard] = useState<number | null>(null);
  const [viewTripDetails, setViewTripDetails] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [viewBookingDetails, setViewBookingDetails] = useState<boolean>(false);
  const [allBookings, setAllBookings] = useState<
    {
      bookingName: string;
      bookingStatus?: string;
      bookingNumber: string;
      startDate: string;
      endDate?: string;
      totalTrips?: number;
      clientDetail?: { clientId: string };
      clientFirstName?: string;
      tripType?: string;
    }[]
  >([]);
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [bookingID, setBookingID] = useState<string>("");
  const [tripData, setTripData] = useState<any>(null);

  const handleViewBookingDetails = (index: number, item: any) => {
    setActiveCardIndex(index);
    setViewBookingDetails(true);
    setClientId(item.bookingId);
    setBookingID(item.bookingId);
  };

  const handleViewTripDetails = (index: number) => {
    setActiveTripCard(index);
    setViewTripDetails(true);
  };

  const fetchMoreData = async () => {
    if (!hasMore || isFetching) return;

    setIsFetching(true);

    try {
      const response: any = await apiService.getApi(
        id
          ? `${OPERTIONS_URL}/booking/get-all-route?entityId=${entityId}&clientId=${id}&page=${page}`
          : `${OPERTIONS_URL}/booking/get-all-route?entityId=${entityId}&page=${page}`
      );

      if (response?.status === "200") {
        const newBookings = response.body.data || [];
        const pagination = response.body.pagination;

        setAllBookings((prev) => [...prev, ...newBookings]);

        // Update pagination details
        setHasMore(pagination.hasNextPage);
        setTotalRecords(pagination.totalRecords);

        if (pagination.hasNextPage) {
          setPage((prev) => prev + 1);
        }
      }
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setHasMore(false);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchMoreData();
  }, [entityId]);

  const effectRan = useRef(false);

  useEffect(() => {
    const fetchTrip = async () => {
      try {
        const response = await getTripData(bookingID);
        if (response?.data) {
          setTripData(response.data);
        } else {
          console.error("Failed to fetch trip data");
        }
      } catch (error) {
        console.error("Error fetching trip data:", error);
      }
    };

    if (bookingID) {
      fetchTrip();
    }
  }, [bookingID]);



  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[30vh]">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="bg-white p-2 rounded-[20px]">
        <div className="flex justify-between border-b border-[#C1C1C1] border-dashed p-2">
          <p className="text-[#444FBD] text-[16px]  font-[600]">
            {`Booking Details (${totalRecords || 0})`}
          </p>
          <CustomButton
            icon={Plus}
            label=""
            onClick={() => navigate("/booking/newbooking")}
          />
        </div>
        <br />
        {/* infinite scroll will be called here */}
        {allBookings.length > 0 ? (
          <div className="flex gap-2 ">
            {/* Left */}
            <InfiniteScrollContainer
              width="400px"
              fetchMoreData={fetchMoreData}
              hasMore={hasMore}
              isFetching={isFetching}
            >
              <div>
                {allBookings?.map((booking: any, index: number) => (
                  <CustomCard
                    key={index}
                    onClick={() => handleViewBookingDetails(index, booking)}
                    isActive={activeCardIndex === index}
                    className="w-[350px] shadow-[1px_-1px_3.6px_2px_#00000033] p-2 rounded"
                  >
                    <div className="gap-[-1]">
                      <div className="flex justify-between items-center ">
                        <div className="flex items-center gap-2 w-fit">
                          <div className="flex-1 min-w-0">
                            <p
                              className="font-semibold truncate"
                              title={booking.bookingName}
                            >
                              {booking.bookingName}
                            </p>
                          </div>
                          <CustomChip
                            text={
                              booking.bookingStatus
                                ? booking.bookingStatus
                                : "Not Assigned"
                            }
                            textColor="#FF973C"
                            borderColor="#FF973C"
                            className="flex-shrink-0"
                          />
                        </div>

                        <p className=" font-[400] text-[14px]">#0{index + 1}</p>
                      </div>
                      <div className=" flex justify-between">
                        <div className="leading-[18px]">
                          <p className="text-[14px]">
                            #{booking.bookingNumber}
                          </p>
                          <p className="text-[14px]">
                            {moment(booking.startDate).format("DD MMMM YYYY, hh:mma")}
                          </p>
                        </div>
                        <div className="flex items-center flex-col  justify-center">
                          <DaysLeftCounter
                            totalDays={
                              booking.totalTrips ? booking.totalTrips : 0
                            }
                          />
                          <p className="text-[14px] font-[400]">Total Trip</p>
                        </div>
                      </div>
                      <div className="flex justify-between items-end">
                        <div className="flex flex-col leading-[15px]">
                          <p className="text-[14px]">Client</p>
                          <button
                            className={`font-medium text-[14px]  ${activeCardIndex === index
                              ? "text-[#F7941D]"
                              : "text-[#444FBD]"
                              }`}
                            onClick={() =>
                              navigate(
                                `/client/view/${booking?.clientDetail?.clientId}`
                              )
                            }
                          >
                            {booking.clientFirstName
                              ? booking.clientFirstName
                              : "Client Name"}
                          </button>
                        </div>
                        <p className="text-[14px] font-[600]">
                          {booking.bookingType ? booking.bookingType : "no type"}
                        </p>
                      </div>
                    </div>
                  </CustomCard>
                ))}
              </div>
            </InfiniteScrollContainer>
            {viewBookingDetails && activeCardIndex !== null && (
              <>
                <div className="mt-[-48px] w-full ">
                  <br />
                  <div className="border-l  border-[#C1C1C1] border-dashed">
                    <div className="flex justify-between items-center  p-2 ">
                      <div className="leading-[15px]">
                        <div
                          className="flex items- space-x-2"
                          title=""
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("view/" + bookingID)}
                        >
                          <SecureImage
                            fileKey={document}
                            alt="header icon"
                            width="60px"
                          />
                          <div>
                            <div className="flex items-center space-x-2 leading-[-15px]">
                              <p className="text-[#444FBD] text-[14px]  font-[600]">
                                {allBookings[activeCardIndex]?.bookingName}
                              </p>
                              <CustomChip
                                text="Ongoing"
                                textColor="#FF973C"
                                backgroundColor="#FFF5EC"
                                borderColor="#FF973C"
                              />
                            </div>
                            <p className="text-[14px]  font-[400]">
                              #{allBookings[activeCardIndex]?.bookingNumber}
                            </p>
                            <p className="text-[14px]  font-[400]">
                              {moment(allBookings[activeCardIndex]?.startDate).format("DD MMMM YYYY, hh:mma")}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-end">
                        <div className="flex flex-col items-end  ">
                          <div className="flex items-center">
                            {allBookings[activeCardIndex]?.startDate &&
                              allBookings[activeCardIndex]?.endDate ? (
                              <>
                                <DaysLeftCounter
                                  totalDays={Math.ceil(
                                    (new Date(allBookings[activeCardIndex]?.endDate ?? "").getTime() -
                                      new Date(allBookings[activeCardIndex]?.startDate ?? "").getTime()) /
                                    (1000 * 60 * 60 * 24)
                                  )}
                                />
                                <p className="text-[14px] font-[400]">
                                  days left
                                </p>
                              </>
                            ) : (
                              <p className="text-[14px] font-[400]">N/A</p>
                            )}
                          </div>

                          <p className="text-[14px]">
                            {moment(allBookings[activeCardIndex]?.endDate).format("DD MMMM YYYY, hh:mma")}
                          </p>
                        </div>
                      </div>
                    </div>
                    <ClientDetailsComponent id={clientId} />
                    <BookingDetails />
                    {/* trip section */}
                    {tripData && tripData.length > 0 ? (
                      <>
                        <div className="flex ">
                          <div className="flex justify-between   p-2 ">
                            <div>
                              <div className="flex justify-between items-center mb-3">
                                <p className="text-[#444FBD] text-[16px] font-[600]">
                                  {`Trip Details (${tripData?.length || 0})`}
                                </p>
                                <CustomButton
                                  label=""
                                  icon={Plus}
                                  onClick={() => {
                                    navigate(`/trip/${bookingID}`);
                                  }}
                                />
                              </div>
                              {
                                console.log(tripData)
                              }
                              {tripData.map((trip: any, index: number) => (
                                <CustomCard
                                  key={index}
                                  onClick={() => handleViewTripDetails(index)}
                                  isActive={activeTripCard === index}
                                  className="w-[350px] shadow-[1px_-1px_3.6px_2px_#00000033] "
                                >
                                  <div className="">
                                    <div className="flex justify-between items-center ">
                                      <div className="flex items-center space-x-2">
                                        <button className="font-semibold" onClick={() => navigate(`/trip/view/trip/${trip.tripId}`)}>
                                          {trip.tripName}
                                        </button>
                                        <CustomChip
                                          text={trip.tripStatus}
                                          textColor="#FF973C"
                                          borderColor="#FF973C"
                                        />
                                      </div>
                                      <p className=" font-[400] text-[14px]">
                                        #0{index + 1}
                                      </p>
                                    </div>
                                    <div className=" flex justify-between ">
                                      <div>
                                        <p className="text-[14px]">
                                          #{trip.tripNumber}
                                        </p>
                                        <p className="text-[14px]  font-[400]">
                                          {moment(trip.startingDateTime).format("DD MMMM YYYY, hh:mma")}
                                        </p>
                                      </div>
                                      <div className="flex items-center flex-col  justify-center">
                                        <DaysLeftCounter
                                          totalDays={
                                            trip.daysLeft ? trip.daysLeft : 0
                                          }
                                        />
                                        <p className="text-[14px] font-[200]">
                                          Days left
                                        </p>
                                      </div>
                                    </div>
                                    <div className="flex justify-between items-end leading-[15px]">
                                      <div>
                                        <p className="text-[14px]">Booking</p>
                                        <button
                                          className={`font-medium  text-[14px] ${activeTripCard === index
                                            ? "text-[#F7941D] "
                                            : "text-[#444FBD]"
                                            }`}
                                          onClick={() =>
                                            alert("Client Name Clicked")
                                          }
                                        >
                                          {trip.bookingName}
                                        </button>
                                      </div>
                                      <div className="leading-[15px]">
                                        <p className="text-[14px] text-right text-[#F7941D] font-[300]">
                                          Point
                                        </p>
                                        <p className="text-[16px] text-[#F7941D] font-[600]">
                                          Clearance
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </CustomCard>
                              ))}
                            </div>
                          </div>

                          <Booking
                            viewTripDetails={viewTripDetails}
                            truck={truck}
                            images={images}
                            tripCard={activeTripCard}
                            activeTripCard={activeTripCard}
                            tripData={tripData}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="flex items-center justify-center flex-col h-[30vh] bg-white ">
                          <h2 className="text-xl font-semibold text-gray-800">
                            No Trip Found
                          </h2>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        ) : (
          <div className="flex items-center justify-center flex-col h-[30vh] bg-white ">
            <h2 className="text-xl font-semibold text-gray-800">
              No Bookings Found
            </h2>
            <p className="text-gray-500 mt-2">
              Click below to add new bookings and manage your records.
            </p>

            <div className="mt-6">
              <CustomButton
                icon={Plus}
                onClick={() => navigate("/booking/newbooking")}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllBooking;